import React, { Component } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2";
import { faInfo, faWrench, faBan, faCogs } from '@fortawesome/free-solid-svg-icons';

import { language, swalText, langs } from "../../../../Constants";

import Helpers from "../../../../libs/helpers";

import './port.scss';

library.add(faInfo, faWrench, faBan, faCogs );
export default class SinglePortfolio extends Component {
    constructor(props){
        super(props)
    }

    changeMain = (images, id) => () => {
        document.querySelector('#myOwnModule').classList.add('openModule');
        document.querySelector('#myOwnModule').dataset.id = id;
        document.addEventListener('click', this.props.closeModule);
        this.props.printImages(images);
    };

    showMore = (data, year) => () => {
        Swal.fire({
            type: 'info',
            confirmButtonText: swalText.ok,
            showCloseButton: true,
            html: `
                <div id='portfolioInfoTag'>
                   <section>
                        <div><b>${language[0].title}: </b>${data[0].title}</div>
                        <div><b>${language[1].title}: </b>${data[1].title}</div>
                        <div><b>${language[2].title}: </b>${data[2].title}</div>
                    </section>
                    <section>
                        <div><b>${language[0].description}: </b>${data[0].text}</div>
                        <div><b>${language[1].description}: </b>${data[1].text}</div>
                        <div><b>${language[2].description}: </b>${data[2].text}</div>
                    </section>
                    <section>
                        <div><b>year: </b> ${year}</div>
                    </section>
                </div>  
            `
        });
    };

    updPortfolio = (data, id, year) => () => {
        Swal.fire({
            type: 'question',
            title: swalText.change,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true,
            html: `
                <div id='portfolioInfoTag'>
                   <section>
                        <div><b>${language[0].title}: </b><input type="text" value="${data[0].title}" required min='3'></div>
                        <div><b>${language[1].title}: </b><input type="text" value="${data[1].title}" required min='3'></div>
                        <div><b>${language[2].title}: </b><input type="text" value="${data[2].title}" required min='3'></div>
                    </section>
                    <section>
                        <div><b>${language[0].description}: </b><textarea required>${data[0].text}</textarea></div>
                        <div><b>${language[1].description}: </b><textarea required>${data[1].text}</textarea></div>
                        <div><b>${language[2].description}: </b><textarea required>${data[2].text}</textarea></div>
                    </section>
                    <section>
                        <div><b>year: </b><input type="number" value="${year}" /></div>
                    </section>
                </div>  
            `
        }).then(result => {
            if (result.value) {
                let tag = document.querySelectorAll('#portfolioInfoTag input, #portfolioInfoTag  textarea');
                let info = [].map.call(tag, el => el.value.trim());
                const year = info.reverse()[0];
                info.reverse();
                info.pop();
                let errors = Helpers.checkErrors(info);
                if (errors.length) {
                    Swal.fire({
                        type: 'error',
                        title: 'Կիսատ ինֆորմացիա',
                        text: 'Լրացրեք բոլոր դաշտերը'
                    });
                    return;
                }

                axios.post('/api/portfolio/upd', { info, id, year }).then(result => {
                    if (result.data.message === 'Updates completed') {
                        let newData = [];
                        langs.map((el, index) => {
                            newData.push({
                                language: el,
                                title: info[index],
                                description: info[index + 3]
                            })
                        });
                        this.props.change(newData, id, year);
                    }
                })
            }
        });
    };

    delPortfolio = id => {
        return function () {
            Swal.fire({
                type: 'question',
                title: swalText.del,
                text: swalText.delMore,
                confirmButtonText: swalText.yes,
                cancelButtonText: swalText.cancel,
                showCloseButton: true,
                showCancelButton: true
            }).then(result => {
                if (result.value) {
                    axios.delete(`/api/portfolio/delById/${id}`).then(({ data }) => {
                        if (data.message === 'portfolio deleted')
                            document.querySelector(`#portfolio-${id}`).remove();
                    })
                }
            })
        };
    };

    render() {
        const { portfolioId: id, data, images, year } = this.props;
        const image = images.find(image => +image.checked === 1);
        return (
            <div className={'portfolio'} id={'portfolio-' + id}>
                <div className={'portfolioImage'}>
                    <img src={'/images/portfolios/' + image.src} alt=""/>
                </div>
                <div className={'portfolioTools'}>
                    <span title={'Տեսնել Ավելին'} onClick={this.showMore(data, year)}><FontAwesomeIcon icon={'info'}/></span>
                    <span title={'Փոխել տեքստերը'} onClick={this.updPortfolio(data, id, year)}><FontAwesomeIcon icon={'wrench'}/></span>
                    <span title={'Փոխել նկարները'} onClick={this.changeMain(images, id)}><FontAwesomeIcon icon={'cogs'}/></span>
                    <span title={'Ջնջել պորտֆոլիոն'} onClick={this.delPortfolio(id)} ><FontAwesomeIcon icon={'ban'}/></span>
                </div>
            </div>
        )
    }
}
